import type { StockAvailability } from 'product/types/Stock'
import type { FragmentItemsFieldsFragment } from '../services/fragments.generated'
import type { ProductInfo } from '../services/graphql.types'

export const LOOK_IMAGE_DEFAULT = '00'
export const TYPE_IMAGES_DEFAULT = ['F', 'O1', 'B'] as const
export const TYPE_IMAGES_DEFAULT_TEST = ['B', 'F', 'O1'] as const
export interface CartProduct {
	productId: string
	colorId: string
	sizeId: string
	look: string
	customized: boolean
	quantity: number
	price: FragmentItemsFieldsFragment['price']
	outOfStock: boolean
	hasLowStock: boolean
	warehouses: string[]
	itemId: string
	seller: string
	info?: ProductInfo
	stock?: StockAvailability
}
